import { app } from '../../../app';

class IdpAuthenticatorsService {

    /** @ngInject */
    constructor($http) {
        this.$http = $http;
    }

    getIdpAuthenticators(companyId) {
        const url = `app/rest/${companyId}/idpauthenticators`;
        return this.$http.get(url).then(({data}) => data);
    }

    createIdpAuthenticator(companyId, name, type) {
        const url = `app/rest/${companyId}/idpauthenticators`;
        const params = {name, type};
        return this.$http.post(url, null, {params}).then(({data}) => data);
    }

    updateIdpAuthenticator(companyId, idpAuthenticator) {
        const url = `app/rest/${companyId}/idpauthenticators/${idpAuthenticator.id}`;
        return this.$http.put(url, idpAuthenticator).then(({data}) => data);
    }

    uploadMetadataXml(companyId, idpAuthenticatorId, metadataStr) {
        const url = `app/rest/${companyId}/idpauthenticators/${idpAuthenticatorId}/saml/metadata`;
        return this.$http.post(url, metadataStr).then(({data}) => data);
    }

    uploadMetadataUrl(companyId, idpAuthenticatorId, metadataUrl) {
        const url = `app/rest/${companyId}/idpauthenticators/${idpAuthenticatorId}/saml/metadataurl`;
        return this.$http.post(url, metadataUrl).then(({data}) => data);
    }

    deleteIdpAuthenticator(companyId, idpAuthenticatorId, params) {
        const url = `app/rest/${companyId}/idpauthenticators/${idpAuthenticatorId}`;
        return this.$http.delete(url, {params}).then(({data}) => data);
    }

    getAssignedApplications(companyId, idpAuthenticatorId) {
        const url = `app/rest/${companyId}/idpauthenticators/${idpAuthenticatorId}/applications`;
        return this.$http.get(url, {params: {type: 'assigned'}}).then(({data}) => data);
    }

    getAssignableApplications(companyId, idpAuthenticatorId) {
        const url = `app/rest/${companyId}/idpauthenticators/${idpAuthenticatorId}/applications`;
        return this.$http.get(url, {params: {type: 'assignable'}}).then(({data}) => data);
    }

    assignApplications(companyId, idpAuthenticatorId, applicationIds) {
        const url = `app/rest/${companyId}/idpauthenticators/${idpAuthenticatorId}/applications`;
        return this.$http.put(url, applicationIds).then(({data}) => data);
    }

    unassignApplications(companyId, idpAuthenticatorId, applicationIds) {
        const url = `app/rest/${companyId}/idpauthenticators/${idpAuthenticatorId}/applications`;
        return this.$http.post(url, applicationIds).then(({data}) => data);
    }
}

app.service('IdpAuthenticatorsService', IdpAuthenticatorsService);


// WEBPACK FOOTER //
// ./src/portal/states/company/idp-authenticators/idp-authenticators.service.js